var frames = require('./frames');
var context = require('../tools/context');

// IN THIS FILE
// given the `streams` array, generate a bacon event stream in the form
// [val_1, val_2, val_3, ... val_n] representing the volume of every
// available stream at the moment.

var data_stream = new Bacon.Bus();

var last_index = 0;
var finished = false;
var playing = false;
var play_offset = 0;

if(!window.streams) {
	console.error('No `streams` object is available.');
	return;
}

function read_data(stream) {
	while(stream[last_index].t <= context.currentTime - play_offset && !finished) {
		// if we can't go any further, quit
		if (!stream[last_index + 1]) {
			finished = true;
			return stream[last_index].v;
		}

		// if we've hit the present, give the latest volume
		if (stream[last_index + 1].t > context.currentTime - play_offset) {
			return stream[last_index].v;
		}

		// if not, increment
		last_index++;
	}
	return stream[last_index].v;
}

frames.onValue( function() {
	if (finished) return;
	if (!playing) return;
	var data = [];
	for(var i = 0; i < window.streams.length; i++) {
		data.push(read_data(window.streams[i]));
	}
	data_stream.push(data);
});

module.exports = {
	stream: data_stream,
	play: function() {
		playing = true;
	},
	pause: function() {
		playing = false;
	},
	offset: function(o) {
		play_offset = o;
	}
};